import { addDays, formatISO } from 'date-fns';

export const getExpiryDate = (invoicingDate: string, paymentTerms?: number) => {
  if (typeof paymentTerms === 'undefined') return undefined;

  const expiryDate = addDays(new Date(invoicingDate), paymentTerms);
  return formatISO(expiryDate);
};
